'use client';
import React, { useEffect } from 'react';
import style from './style.module.scss';
import searchIcon from '../../public/search-icon.svg';

import { useDebounce } from '@/hooks';
import Image from 'next/image';
import { BackButton } from '..';

interface NewsSearchBarProps {
  link: string;
  searchValue?: string;
  setSearchValue?: (arg: string) => void;
  onSearch?: (value: string) => void;
}

export const NewsSearchBar = ({
  link,
  searchValue,
  setSearchValue,
  onSearch,
}: NewsSearchBarProps) => {
  const debouncedSearchValue = useDebounce(searchValue || '', 500);

  useEffect(() => {
    if (onSearch) {
      onSearch(debouncedSearchValue);
    }
  }, [debouncedSearchValue, onSearch]);

  return (
    <div className={style.wrapper}>
      <BackButton link={link} />
      <div className={style.search}>
        <input
          value={searchValue}
          onChange={(e) => {
            if (setSearchValue) {
              setSearchValue(e.target.value); // Обновляем значение сразу
            }
          }}
          className={style.input}
          type="text"
          placeholder="поиск"
        />
        <Image width={22} height={22} src={searchIcon} className={style.icon} alt="search" />
      </div>
    </div>
  );
};